(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("qs"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["qs", "axios"], factory);
	else if(typeof exports === 'object')
		exports["apiCore"] = factory(require("qs"), require("axios"));
	else
		root["apiCore"] = factory(root["qs"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__796d__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 